import { useFormStore } from "../formStore"
import StepLayout from "../StepLayout"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import CheckboxField from "../../fields/Checkbox"
import RadioField from "../../fields/Radio"
import TextField from "../../fields/Text"
import SelectField from "../../fields/Select"
import FileField from "../../fields/File"
import { z } from "zod"

import styles from "./OverviewStep.module.scss"
import Button from "../../../Button"
import { useEffect, useState } from "react"
import cx from "classnames"
import axios from "axios"
import getConfig from "next/config"

const {
  publicRuntimeConfig: { API_URL },
} = getConfig()

const FIELDS = {
  radio: RadioField,
  text: TextField,
  select: SelectField,
  file: FileField,
  check: CheckboxField,
}
const OverviewStep = ({}) => {
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const [employee, setEmployee] = useState(null)

  const { getStep, prevStep, nextStep, resetStore, setData, data, products } =
    useFormStore((state) => ({
      getStep: state.getStep,
      prevStep: state.prevStep,
      nextStep: state.nextStep,
      setData: state.setData,
      resetStore: state.resetStore,
      data: state.data,
      products: state.products,
    }))

  const step = getStep()

  useEffect(() => {
    if (data?.booked_employee) {
      setEmployee(JSON.parse(data.booked_employee))
    }
  }, [data])

  const methods = useForm({
    defaultValues: {
      consented: null,
    },
    resolver: zodResolver(
      z.object({
        consented: z.literal(true),
      })
    ),
  })

  const CONCERNS = {
    planning_application: "Bauantragscheck",
    other: "Anderes Anliegen",
  }

  const {
    watch,
    formState: { isValid },
    handleSubmit,
  } = methods

  const onSubmit = async () => {
    setLoading(true)
    const { data } = useFormStore.getState()
    const {
      booked_time: bookedTime,
      booked_type,
      booked_employee,
      firstname,
      lastname,
      email,
      concern,
      arc_additional_info,
    } = data

    const bookedEmployee = JSON.parse(booked_employee)
    const bookedType = JSON.parse(booked_type)

    const submissionResponse = await axios.post(
      `${API_URL}/!/form/architekt_on_demand`,
      {
        firstname,
        lastname,
        email,
        phone,
        concern,
        booked_employee: bookedEmployee?.title ?? "-",
        booked_type: bookedType?.name ?? "-",
        booked_time: bookedTime,
        arc_additional_info: arc_additional_info,
      }
    )

    if (submissionResponse?.status !== 200) {
      setError(true)
      setLoading(false)
      return
    }

    try {
      const result = await axios.post(`${API_URL}/acuity/create`, {
        calendarId: bookedEmployee?.employee_calendar_id,
        appointmentTypeId: bookedType?.id,
        bookedTime,
        firstName: firstname,
        lastName: lastname,
        email,
        phone,
        intakeFormResponses:[
          {
            Rechnungsadresse: "Termin als Firma buchen?",
            value: "Yes"
          }
        ]
      })

      if (!result || !result.data || !result.data.confirmationPage) {
        setError(true)
        setLoading(false)
        return
      }
      else{
        window.location.href = result.data.confirmationPage
      }

    } catch (e) {
      console.log(e)
      setError(true)
      setLoading(false)
    }
  }

  const {
    firstname,
    lastname,
    email,
    phone,
    booked_time,
    booked_date,
    booked_type,
    concern,
    arc_additional_info,
  } = data

  const bookedDate = new Date(booked_date).toLocaleDateString("de-DE", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  })
  const bookedTime = new Date(booked_time).toLocaleTimeString().split(":")
  const bookedType = JSON.parse(booked_type)

  if (!employee) return null

  return (
    <>
      <StepLayout
        question={step.question}
        image={step.image}
        progress={step.progress}
        className={cx({ "pb-64": products })}
      >
        <div className="mb-8">
          <div className="text-body font-semibold mb-4">Ihr Termin</div>
          <div>
            <div className="mb-1.5">
              <span className="text-body-small font-semibold">Berater: </span>
              {employee.title}
            </div>
            <div className="mb-1.5">
              <span className="text-body-small font-semibold">Terminart: </span>
              {bookedType.name}, {bookedType.duration} Min., {bookedType.price}€
            </div>
            <div className="mb-1.5">
              <span className="text-body-small font-semibold">
                Ausgewähltes Datum:{" "}
              </span>
              {bookedDate}
            </div>
            <div>
              <span className="text-body-small font-semibold">
                Ausgewählte Uhrzeit:{" "}
              </span>
              {bookedTime[0]}:{bookedTime[1]}
            </div>
            <div>
              <span className="text-body-small font-semibold">
                Ihr Anliegen:{" "}
              </span>
              {CONCERNS[concern]}
            </div>
          </div>
        </div>

        <div className="mb-8">
          <div className="text-body font-semibold mb-4">Weitere Informationen:</div>
          <div>
            <div className="mb-1.5">
              {arc_additional_info}
            </div>
          </div>
        </div>

        <div className="mb-8">
          <div className="text-body font-semibold mb-4">Angaben zur Person</div>
          <div>
            <div className="mb-1.5">
              <span className="text-body-small font-semibold">Name: </span>
              {firstname} {lastname}
            </div>
            <div className="mb-1.5">
              <span className="text-body-small font-semibold">E-Mail: </span>
              {email}
            </div>
            <div>
              <span className="text-body-small font-semibold">
                Telefonnummer:{" "}
              </span>
              {phone}
            </div>
          </div>
        </div>

        <div className="mb-8 last:mb-0">
          <div className="text-body font-semibold mb-4">
            Zahlungsinformationen
          </div>
          <div className="text-body-small">
            <p>
              Terminänderung oder Bezahlung erfolgt über einen Link in der Bestätigungsmail. <br/>
              Bei zahlungspflichtigen Terminen gilt: <br/>
              1. Zahlung nur mit Kreditkarte möglich und muss bis 1 Std. vor Terminbeginn erfolgt sein. <br/>
              2. Verschiebung bis 1 Std. vor Terminbeginn kostenlos möglich. <br/>
              3. Erstattung bei Stornierung nur bis 2 Kalendertage vor Terminbeginn möglich.
            </p>
          </div>
        </div>
      </StepLayout>

      {submitted && error && (
        <div className="mt-16 container max-w-xl rounded-md py-4 px-4 mb-16 border-2 text-center border-red-400 bg-red-200 text-red-800">
          Ihre Anfrage konnte leider nicht versendet werden.
          <br />
          Bitte versuchen Sie es erneut, oder schreiben Sie eine E-Mail an{" "}
          <a
            className="underline underline-offset-2"
            href="mailto:anfrage@planmaschine.de"
          >
            anfrage@planmaschine.de
          </a>
        </div>
      )}

      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        {step?.fields?.map((field, i) => {
          const Field = FIELDS?.[field?.field_type]

          return Field ? (
            <Field key={i} field={field} methods={methods} />
          ) : null
        })}
        <div className="container flex justify-center items-center py-10 gap-4">
          <Button
            displayType={{ value: "button_tertiary" }}
            iconPosition={{ value: "left" }}
            onClick={prevStep}
          >
            Zurück
          </Button>
          <Button
            displayType={{ value: "button_primary" }}
            iconPosition={{ value: "right" }}
            type="submit"
            disabled={!isValid}
            loading={loading}
          >
            Weiter
          </Button>
        </div>
      </form>
    </>
  )
}

export default OverviewStep
